import { getQueryParam } from '../../routing/getQueryParam';
import { Step } from '../../views/Step';
import { CONTROL, VARIANT } from '../experimentDefaults';
export const ACQ111_WEBSITE_TREATMENT_QUERY_PARAM = 'acq-111-treatment';
const ACQ111_HUBS_SIGNUP_URLS = ['www.hubspot.com/products/sales/schedule-meeting', 'www.hubspot.es/products/sales/schedule-meeting'];
export const getHasHubsSignupUrlParamForACQ111 = () => {
  const hubsSignupUrlParamCleanPath = decodeURIComponent(getQueryParam('hubs_signup-url')).split('?')[0];
  const hasHubsSignupUrlParam = ACQ111_HUBS_SIGNUP_URLS.includes(hubsSignupUrlParamCleanPath);
  return hasHubsSignupUrlParam;
};
export const getIsEnrolledForACQ111 = () => {
  const acq111WebsiteTreatment = getQueryParam(ACQ111_WEBSITE_TREATMENT_QUERY_PARAM);
  const hasAcq111WebsiteTreatment = [CONTROL, VARIANT].includes(acq111WebsiteTreatment);
  const hasHubsSignupUrlParamForACQ111 = getHasHubsSignupUrlParamForACQ111();
  return hasAcq111WebsiteTreatment && hasHubsSignupUrlParamForACQ111;
};
export const isACQ111WebsiteVariant = () => {
  const acq111WebsiteTreatment = getQueryParam(ACQ111_WEBSITE_TREATMENT_QUERY_PARAM);
  const isEnrolledForACQ111 = getIsEnrolledForACQ111();
  return isEnrolledForACQ111 && acq111WebsiteTreatment === VARIANT;
};
export const isOnIndustryStepAndCredentialVerifiedNewUser = (currentStep, isGoogleCredentialAuthentication, isExistingOAuthUser) => {
  const isEnrolledForACQ111 = getIsEnrolledForACQ111();
  return isEnrolledForACQ111 && isGoogleCredentialAuthentication && currentStep === Step.Industry && !isExistingOAuthUser;
};